// start:ng42.barrel
export * from './service.error';
export * from './http.error.trace';
// end:ng42.barrel



// WEBPACK FOOTER //
// ./src/main/webapp/stay-mgmt/app/common/error/index.ts